import React, { useState } from "react";
import "../styles/ContainerSelector.css"; // Import the CSS file

const ContainerSelector = ({ containers, onSelect }) => {
  const [selectedContainer, setSelectedContainer] = useState("");

  const handleChange = (event) => {
    let value = event.target.value;
    if (value === "") {
      value = null;
    }
    setSelectedContainer(value);
    onSelect(value);
  };

  return (
    <div className="container-selector">
      <select value={selectedContainer} onChange={handleChange}>
        <option value="">Select a container</option>
        {containers.map((container, index) => (
            <option key={index} value={container}>
                {container}
            </option>
        ))}
      </select>
    </div>
  );
};

export default ContainerSelector;